import { Alert } from "react-bootstrap";

interface Props {
  children?: React.ReactNode;
  className?: string;
}

export const DangerAlert: React.FC<Props> = ({ children, className }) => (
  <div className={className}>
    <Alert className="alert--icon-danger-vertical" variant="danger">
      {children}
    </Alert>
  </div>
);
